import { IFilterField } from 'models/types';
import { useTranslation } from 'react-i18next';

export const useOrganisationAssignmentFilterSchema = (): IFilterField[] => {
  const { t } = useTranslation('default');
  return organisationAssignmentFilterSchema(t);
};

export const organisationAssignmentFilterSchema = (t: (key: string) => string): IFilterField[] => {
  return [
    {
      label: t('name-contains'),
      name: 'name',
      widget: 'text',
    },
  ];
};
